(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-banner"] && !Shopify.designMode) return;
  try {
    
  // Theme addition (as in 1.2.3): keyboard focus on a row also shows its background image; Bera's gallery-component only
  // reacts to the mouse.
  document.querySelectorAll('.collection-list-with-banner gallery-component').forEach(function (gallery) {
    gallery.querySelectorAll('.gallery-content .content-item').forEach(function (item, index) {
      item.addEventListener('focusin', function () {
        if (typeof gallery.setActiveBlock === 'function') gallery.setActiveBlock(index);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
/* Clasp & Bloom 1.19.4: Cookie preferences opens on the FIRST click, also while Shopify's privacy library is still loading.
   Before: the click was ignored (or followed the fallback link) when window.privacyBanner was not ready yet, so only the second click worked.
   Now: the original click is remembered, the link shows a short loading state and the panel opens as soon as the library is ready;
   after ten seconds without a panel the fallback link (privacy policy) is followed. */
(function () {
  var busy = false;
  function panelOpen() {
    var panel = document.getElementById('shopify-pc__prefs');
    return !!(panel && panel.getClientRects().length && getComputedStyle(panel).visibility !== 'hidden');
  }
  function setLoading(link, on) {
    if (on) {
      link.setAttribute('aria-busy', 'true');
      link.classList.add('is-loading');
      link.setAttribute('data-cb-label', link.textContent);
      link.textContent = link.getAttribute('data-loading-label') || 'Opening\u2026';
    } else {
      link.removeAttribute('aria-busy');
      link.classList.remove('is-loading');
      if (link.hasAttribute('data-cb-label')) { link.textContent = link.getAttribute('data-cb-label'); link.removeAttribute('data-cb-label'); }
    }
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-cookie-preferences]');
    if (!link) return;
    var href = link.getAttribute('href');
    event.preventDefault();
    if (busy) return;
    busy = true;
    setLoading(link, true);
    var started = Date.now(), lastCall = 0, calls = 0;
    (function step() {
      if (panelOpen()) { busy = false; setLoading(link, false); return; }
      var banner = window.privacyBanner;
      var now = Date.now();
      if (banner && typeof banner.showPreferences === 'function' && calls < 4 && now - lastCall > 1200) {
        calls++; lastCall = now;
        try { banner.showPreferences(); } catch (e) {}
      }
      if (now - started > 10000) {
        busy = false; setLoading(link, false);
        if (href && href !== '#') window.location.href = href;
        return;
      }
      setTimeout(step, 100);
    })();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  /* Clasp & Bloom 1.5.0: the header hides while scrolling down and comes back as soon as the visitor scrolls up, on
     every page type. It stays put while a menu, dropdown or panel is open or has focus, and only reacts to a scroll of
     more than a few pixels (no flicker). --cb-header-offset tells sticky elements (filter bar) how much room it takes. */
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (this.getAttribute('data-sticky-type') !== 'sticky' || !this.header) return;
    const header = this.header;
    const root = document.documentElement;
    header.classList.add('wdt-scroll-sticky');
    let last = window.scrollY;
    let hidden = false;
    let ticking = false;
    const height = () => header.offsetHeight;
    const busy = () =>
      !!header.querySelector(':focus-visible') ||
      !!header.querySelector('.dt-desktop-menu .nav-item:hover') ||
      !!document.querySelector('.offcanvas.show, .offcanvas.showing, body.facet-drawer-open');
    const show = () => {
      hidden = false;
      header.classList.remove('wdt-header-top');
      header.style.top = '0px';
      root.style.setProperty('--cb-header-offset', height() + 'px');
    };
    const hide = () => {
      hidden = true;
      header.classList.add('wdt-header-top');
      header.style.top = '-' + (height() + 8) + 'px';
      root.style.setProperty('--cb-header-offset', '0px');
    };
    const update = () => {
      ticking = false;
      const y = window.scrollY;
      const delta = y - last;
      header.classList.toggle('cb-header-scrolled', y > 2);
      if (y <= height()) {
        if (hidden) show();
      } else if (delta > 6 && !hidden && !busy()) {
        hide();
      } else if (delta < -6 && hidden) {
        show();
      }
      if (Math.abs(delta) > 6 || y <= height()) last = y;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    header.addEventListener('focusin', () => { if (hidden && header.querySelector(':focus-visible')) show(); });
    window.addEventListener('resize', () => { if (!hidden) root.style.setProperty('--cb-header-offset', height() + 'px'); });
    show();
  }
}
customElements.define('sticky-header', StickyHeader);
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-target]').forEach((button) => {
    button.addEventListener('click', function () {
      const targetSelector = this.getAttribute('data-target');
      const offcanvasElement = document.querySelector(targetSelector);
      if (offcanvasElement) new bootstrap.Offcanvas(offcanvasElement).show();
    });
  });
  document.querySelectorAll('a[role="button"]').forEach((button) => {
    button.addEventListener('keydown', function (e) {
      if (e.code === 'Space' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });
  const subMenu = () => {
    const dropdown_subMenu = document.querySelectorAll('.dropdown-menu.sub-menu');
    const window_Width = document.querySelector('body').clientWidth;
    dropdown_subMenu.forEach((item) => {
      const thisItemRight = item.getBoundingClientRect().right;
      if (window_Width < thisItemRight) item.classList.add('wdt_float_left');
      else item.classList.remove('wdt_float_left');
    });
  };
  subMenu();
  window.addEventListener('resize', subMenu);
});

/* Theme accessibility addition (kept from 1.2.x, A10): Bera opens the desktop mega menu and dropdowns with CSS only (hover and
   focus-within). Escape closes an open menu while focus stays on its menu item, and aria-expanded follows the state. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.dt-desktop-menu > .nav-item').forEach((item) => {
    const trigger = item.querySelector('.dropdown-toggle');
    if (!trigger) return;
    const setExpanded = (open) => trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.addEventListener('mouseenter', () => { item.classList.remove('ns-menu-closed'); setExpanded(true); });
    item.addEventListener('mouseleave', () => { if (!item.contains(document.activeElement)) setExpanded(false); });
    item.addEventListener('focusin', () => { if (!item.classList.contains('ns-menu-closed')) setExpanded(true); });
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) { item.classList.remove('ns-menu-closed'); setExpanded(item.matches(':hover')); }
    });
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !item.classList.contains('ns-menu-closed')) {
        item.classList.add('ns-menu-closed');
        setExpanded(false);
        trigger.focus();
      } else if (e.target === trigger && item.classList.contains('ns-menu-closed') && (e.key === 'ArrowDown' || e.key === ' ')) {
        e.preventDefault();
        item.classList.remove('ns-menu-closed');
        setExpanded(true);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  // Theme addition (as in 1.2.3): hotspots report the selected state to screen readers. Bera's shop-look-section marks the
  // selected hotspot with the class 'active'; aria-pressed follows that class.
  document.querySelectorAll('shop-look-section .spots').forEach(function (spot) {
    var sync = function () {
      spot.setAttribute('aria-pressed', spot.classList.contains('active') ? 'true' : 'false');
    };
    sync();
    new MutationObserver(sync).observe(spot, { attributes: true, attributeFilter: ['class'] });
  });

  // Clasp & Bloom 1.4.10: product/image pairs. The image of the active card is shown; card and image share the block id
  // (data-id), so the pairing never depends on file or slide order. Arrows, swipe and the keyboard all move the one
  // existing slider; the image follows on every slide change and once more when the transition ends.
  document.querySelectorAll('shop-look-section').forEach(function (root) {
    var slider = root.querySelector('[data-shop-look-slider]');
    var medias = root.querySelectorAll('[data-ns-look-media]');
    if (!slider || medias.length === 0) return;
    var attach = function (tries) {
      var swiper = slider.swiper;
      if (!swiper) {
        if (tries < 100) requestAnimationFrame(function () { attach(tries + 1); });
        return;
      }
      var sync = function () {
        var slide = swiper.slides[swiper.activeIndex];
        var id = slide ? slide.getAttribute('data-id') : null;
        medias.forEach(function (media) {
          media.hidden = media.getAttribute('data-id') !== id;
        });
      };
      // Hidden images with loading="lazy" only start loading when shown, which leaves an empty frame while the
      // slide changes; once the section is near the viewport, all worn images load.
      var preload = function () {
        root.querySelectorAll('[data-ns-look-media] img').forEach(function (img) {
          img.loading = 'eager';
        });
      };
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            preload();
            observer.disconnect();
          }
        }, { rootMargin: '400px 0px' });
        observer.observe(root);
      } else {
        preload();
      }
      swiper.on('slideChange', sync);
      swiper.on('slideChangeTransitionEnd', sync);
      sync();
      root.addEventListener('keydown', function (event) {
        if (event.target.closest('input, select, textarea')) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          swiper.slidePrev();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          swiper.slideNext();
        }
      });
    };
    attach(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
  // Bera (compiled_assets/scripts.js of the demo): half the icon height as --before-top on each item.
  function initWdtIcon() {
    document.querySelectorAll('.text-with-icon-item').forEach(function (wdtItem) {
      var wdtItemHeight = wdtItem.clientHeight / 2;
      wdtItem.closest('.section-text-with-icon').setAttribute('style', '--before-top: ' + wdtItemHeight + 'px;');
    });
  }
  initWdtIcon();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  // Theme addition (as in 1.2.3): with reduced motion the video starts paused (the browser controls stay); YouTube/Vimeo is
  // only loaded after a click.
  document.querySelectorAll('[data-ns-video-section]').forEach(function (root) {
    var video = root.querySelector('video');
    if (video && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.pause();
      video.removeAttribute('autoplay');
    }
  });
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ns-load-external-video]');
    if (!button) return;
    var holder = button.closest('[data-ns-external-video]');
    if (!holder) return;
    var parts = holder.getAttribute('data-ns-external-video').split(':');
    var src = parts[0] === 'vimeo'
      ? 'https://player.vimeo.com/video/' + encodeURIComponent(parts[1]) + '?autoplay=1&dnt=1'
      : 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(parts[1]) + '?autoplay=1&rel=0';
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = button.getAttribute('aria-label') || 'Video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.className = 'w-100 h-100';
    holder.innerHTML = '';
    holder.appendChild(iframe);
    iframe.focus();
  });

  } catch(e) { console.error(e); }
})();
})();
